module.exports = __webpack_public_path__ + "static/media/concert-guidelines.2d26b20e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/choir/concert-guidelines.pdf
// module id = 203
// module chunks = 0